// Alfa Fashion trees on the shared PKR catalog.
// A product is fashion when one of its categories is one of these roots
// or a child of one. Every other category is conventional.
const FASHION_ROOTS = [
  "fashion",
  "women-fahion",
  "men-fashion",
  "womenswear",
  "menswear",
];

/**
 * True when the handle belongs to an Alfa Fashion category tree.
 */
export function isFashionCategoryHandle(handle) {
  if (!handle || typeof handle !== "string") return false;
  const normalized = handle.trim().toLowerCase();
  if (!normalized) return false;
  return FASHION_ROOTS.some(
    (root) => normalized === root || normalized.startsWith(`${root}/`)
  );
}

/** Newest Alfa Fashion handle in the visited list, or null. */
export function pickFashionCategoryHandle(handles) {
  if (!Array.isArray(handles)) return null;
  for (let i = handles.length - 1; i >= 0; i -= 1) {
    if (isFashionCategoryHandle(handles[i])) return handles[i];
  }
  return null;
}

/** Fallback catalog for the fashion section the shopper is in. */
export function defaultFashionCategoryHandle({ pathname, gender } = {}) {
  const onMens =
    (typeof pathname === "string" && pathname.includes("/fashion/men")) ||
    gender === "men";
  return onMens ? "menswear" : "women-fahion";
}

/** True when the product itself is tagged on an Alfa Fashion tree. */
export function productIsFashion(product) {
  const cats = Array.isArray(product?.category)
    ? product.category
    : product?.category
      ? [product.category]
      : [];
  return cats.some((cat) =>
    isFashionCategoryHandle(cat?.handle || cat?.title)
  );
}
